const mediaItems = [
  {
    title: '久久视频 · 热播剧场',
    desc: '最新热播剧集一键直达，高清画质流畅播放',
    tag: '剧集',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20streaming%20interface%20showing%20drama%20series%20thumbnails%20in%20a%20modern%20layout%2C%20warm%20cinematic%20lighting%2C%20film%20reel%20motif%2C%20professional%20video%20platform%20design%2C%20coral%20and%20amber%20color%20scheme&width=640&height=360&seq=media-01-2026&orientation=landscape',
  },
  {
    title: '芒果视频 · 综艺现场',
    desc: '独家综艺节目，每周更新不断',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20variety%20show%20stage%20scene%20with%20dynamic%20lighting%2C%20entertainment%20atmosphere%2C%20modern%20broadcast%20studio%20design%2C%20vibrant%20warm%20colors%2C%20show%20production%20theme&width=640&height=360&seq=media-02-2026&orientation=landscape',
  },
  {
    title: '97视频 · 精彩推荐',
    desc: '智能推荐，发现属于你的视频内容',
    tag: '推荐',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20discovery%20app%20interface%20with%20personalized%20content%20cards%2C%20sleek%20UI%20design%2C%20warm%20gradient%20background%2C%20trending%20video%20previews%2C%20contemporary%20digital%20media%20aesthetic&width=640&height=360&seq=media-03-2026&orientation=landscape',
  },
  {
    title: '丝瓜视频 · 电影大片',
    desc: '海量电影资源，足不出户看大片',
    tag: '电影',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20streaming%20interface%20with%20Hollywood%20blockbuster%20posters%2C%20warm%20theater-like%20atmosphere%2C%20film%20strip%20elements%2C%20modern%20video%20platform%20design%2C%20rich%20amber%20and%20coral%20accents&width=640&height=360&seq=media-04-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-play-list-2-line"></i>
            精彩内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门视频内容速览
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            各平台精选内容一览，发现您感兴趣的视频类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all group cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-background-50/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-primary-500 text-xl"></i>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-block px-2 py-1 rounded-md bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}